// Le catalogue source est écrit imbriqué (lisibilité, recherche, regroupement
// par domaine) mais tout le moteur — diff, hash, stockage Mongo, catalogues
// servis au client — travaille sur des chemins pointés plats. L'aplatissement
// est la seule frontière entre les deux formes.
/**
 * Aplatit un arbre de messages en chemins pointés. L'ordre des clés produites
 * suit l'ordre de déclaration ; il n'a aucune incidence sur `computeSourceVersion`,
 * qui trie avant de hasher.
 */
export function flattenMessages(tree, prefix = "") {
    const flat = {};
    for (const [segment, value] of Object.entries(tree)) {
        const path = prefix ? `${prefix}.${segment}` : segment;
        if (typeof value === "string") {
            flat[path] = value;
        }
        else {
            Object.assign(flat, flattenMessages(value, path));
        }
    }
    return flat;
}
//# sourceMappingURL=flatten.js.map